// extracted by mini-css-extract-plugin
export default {"container":"Tints_container__UXGvE","wrap":"Tints_wrap__fwIVh","tint":"Tints_tint__qbdLi","color":"Tints_color__vxrso","label":"Tints_label__IdOda"};